import React, { useEffect } from 'react';
import ApexCharts from 'apexcharts';
import { chartOptions } from '../consts';

export function SessionsGraph({ data, merchantId, merchants }) {
	const id = 'sessions-graph';

	useEffect(() => {
		const element = document.getElementById(id);

		if (!element) {
			return;
		}
		const options = getChartOption(data, merchantId, merchants);
		const chart = new ApexCharts(element, options);
		chart.render();

		return function cleanUp() {
			chart.destroy();
		};
	}, [data, merchants, merchantId]);

	return <div id={id}></div>;
}

function getChartOption(data, merchantId, merchants) {
	const sessionsData = data.map((entry) => {
		// accept 'sessions' or 'Sessions'
		const total = entry.metrics.sessions || entry.metrics.Sessions || 0;
		return {
			total,
			merchantId: entry.merchantId,
			ts: entry.ts
		}
	})
	const series =
		merchantId === 'all'
			? merchants.map((m) => ({
				name: m.label,
				data: sessionsData.map((d) => d.merchantId === m.merchantId ? d.total : 0),
			}))
			: [
				{
					name: 'Sessions',
					data: sessionsData.map((d) => d.total || 0),
				},
			];
	const preOptions = chartOptions(sessionsData);
	preOptions.yaxis = {
		...preOptions.yaxis,
		labels: {
			formatter: (v) => parseInt(v),
		},
	};
	const options = {
		series,
		colors: ['#FE6F5E', '#17C5BD', '#D55DB1', '#835FC2', '#FFC75F'],
		...preOptions,
	};
	return options;
}
